/* eslint-disable */

import Web3 from "web3";

const web3 = new Web3(Web3.givenProvider);

/**
 * Check network is correct
 * bsc testnet on staging
 * bsc on product
 * return true if correct network
 *        false if wrong network
 */
export function checkCorrectNetwork(network) {
  // console.log(network)
  if (network === 97) {
    // bsc testnet
    return true;
  } else return false;
}

/**
 *
 * @returns address,netwok or false
 */
export async function connectMetamask() {
  return new Promise(async (resolve, reject) => {
    if (!window.ethereum) { // browser do not have any wallet extension
      resolve(false);
    }
    else if (window.ethereum.isMetaMask) {//browser has metamask
      const result = await requiredConnectWallet();
      resolve({
        address: result.address,
        network: result.network
      });
    }
  })
}

/** 
 * 
 * @returns address,network
*/
export async function requiredConnectWallet() {
  return new Promise(async (resolve, reject) => {
    try {
      await window.ethereum.request({ method: 'eth_requestAccounts' });
      const accounts = await web3.eth.getAccounts()
      const network = await web3.eth.net.getId();
      resolve({
        address: accounts[0],
        network: network
      });
    } catch (error) { //sth wrong when connect metamask
      console.log(error)
      resolve({
        address: null,
        network: null
      });
    }
  })
}

/**
 * 
 * @returns network
 */
 export async function requiredSwitchNetwork() {
  return new Promise(async (resolve, reject) => {
    try {
      let params = [
        {
          "chainId": "0x61",
          "chainName": "BSC Testnet",
          "rpcUrls": ["https://data-seed-prebsc-1-s2.binance.org:8545"],
          "nativeCurrency": {
            "name": "BNB",
            "symbol": "BNB",
            "decimals": 18
          },
          "blockExplorerUrls": ["https://testnet.bscscan.com"]
        },
      ];
      await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: params,
      });
      const chainId = await web3.eth.net.getId();
      resolve(chainId);
    } catch (switchError) { //Metamask do not have that network, need to add and switch
      console.log(switchError);
      reject(addError);
      console.log(addError);
    }
  })
}

/**
 * 
 * @param {*} address 
 * @returns string
 */
export function reduceAddressLength(address: string) {
  if (address && address.length > 1) {
    return address.slice(0, 6) + '...' + address.slice(address.length - 4, address.length)
  }
  else return address
}

/**
 *
 * @param {*} address
 * @returns object
 */
export async function signedLogin(address: string) {
  return new Promise(async (resolve, reject) => {
    const time = Date.now()
    const message = address + ':' + time
    // console.log('message:' + message)
    try {
      let result = await web3.eth.personal.sign(message, address)
      // console.log('result: ')
      // console.log(result)
      resolve({
        address: address,
        unixTime: time,
        signedTx: result
      })
    }
    catch (err) {
      reject('user cancel')
    }
  })
}

/**
 * 
 * @param {*} addresses 
 * @returns true if 2 address the same, false if not
 */
export function compareAddresses(address: string, localAddress: string) {
  if (address && address === localAddress) return true
  else return false
}